module.exports = __webpack_public_path__ + "img/T58.0bcc98d8.jpg";